<template>
<div class="column experience__stats has-text-centred">
    <div class="experience__stats__inner">
        <span class="has-text-white icon"><i :class="item.icon"></i></span>
        <p class="title is-2">{{item.stats}}</p>
        <p class="subtitle is-4">{{item.title}}</p>
    </div>
</div>
</template>

<script>
export default {
    name    :   'Stats',
    props   :   ['is_visible', 'item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/Stats.vue